import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex-container-row align-start" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "k-icon k-i-file-pdf redText",
  style: {"margin-right":"5px","margin-top":"6px","line-height":"1.5"}
}, null, -1)
const _hoisted_3 = {
  class: "flex-container-col",
  style: {"margin-bottom":"5px"}
}
const _hoisted_4 = {
  key: 0,
  class: "doc-description"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_download_info = _resolveComponent("download-info")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_download_info, { isDownloading: _ctx.isDownloading }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("a", {
            class: "textlink",
            href: "#",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.downloadDoc(_ctx.doc.blobName)), ["prevent"]))
          }, _toDisplayString(_ctx.computedDisplayName), 1),
          (_ctx.description != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.description), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["isDownloading"])
  ]))
}